'use strict';

/**
 *
 * @name: joinUs
 *
 */

import DirectiveTemplate from './nn-join-us.directive.html';
import './nn-join-us.directive.scss';

function JoinUsDirective() {

  'ngInject';

  return {
    replace: true,
    restrict: 'A',
    scope: {
      content: '&',
      loaded: '='
    },
    template: DirectiveTemplate,
    transclude: true,
    link: function(scope) {

      scope.item = scope.content();
      scope.loaded = true;
    }
  };
}

export default JoinUsDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modules/nn-join-us/nn-join-us.directive.js